/**
 * Initializes the collapser functionality for all elements with the "collapser" class.
 * @function
 * @returns {void}
 */
export function collapser() {
    const collapserButtons = document.querySelectorAll(".collapser");

    collapserButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const collapsingHeader = button.closest("header");
            button.classList.toggle("is-collapsed");

            if (collapsingHeader) {
                let nextSibling = collapsingHeader.nextElementSibling;

                while (nextSibling) {
                    if (nextSibling.tagName === "DIV") {
                        nextSibling.hidden = !nextSibling.hidden;
                        break;
                    }
                    nextSibling = nextSibling.nextElementSibling;
                }
            }
        });
    });
}
